import React from "react";
import { Routes, Route } from "react-router-dom";
import List from "./List";
import Details from "./Details";
import Templates from "./Templates";
import DebriefPdfReportForm from "./DebriefPdfReportForm";
import CopyGlobalToOrgTemplate from "./CopyGlobalToOrgTemplate";
import Scanner from "./Scanner";
import { Header } from "semantic-ui-react";

import { useNavigate } from "react-router-dom";

function PdfReports() {
  const navigate = useNavigate();
  return (
    <>
      <Routes>
        <Route path="/" element={<List />} />
        <Route path="details/:id" element={<Details />} />
        <Route path="scanner" element={<Scanner />} />
        <Route path="templates" element={<Templates />} />
        <Route path="create" element={<DebriefPdfReportForm />} />
        <Route path="edit/:id" element={<DebriefPdfReportForm isEdit={true} />} />
        <Route path="copy-global-to-org" element={<CopyGlobalToOrgTemplate />} />
      </Routes>
    </>
  );
}

export default PdfReports;
